import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#0a0a0a',
      paper: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%)',
    },
    text: {
      primary: '#e0e0e0', // Light gray text
      secondary: '#b0b0b0',
    },
    primary: {
      main: '#ffffff', // White for buttons
    },
    secondary: {
      main: '#ff5555', // Red for delete/cancel
    },
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
    h1: { fontSize: '2.2rem', fontWeight: 700, letterSpacing: '0.8px' },
    h2: { fontSize: '1.8rem', fontWeight: 600 },
    h3: { fontSize: '1.6rem', fontWeight: 600 },
    body1: { fontSize: '1.1rem', fontWeight: 400 },
    button: { fontSize: '1.2rem', fontWeight: 600 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          textTransform: 'none',
          padding: '16px 30px',
          transition: 'all 0.3s ease',
          background: 'linear-gradient(90deg, #ffffff, #e0e0e0)',
          color: '#0a0a0a', // Black text default
          '&:hover': {
            background: '#e0e0e0', // Light gray on hover, no black
            color: '#0a0a0a', // Keep black text
            transform: 'translateY(-3px)',
            boxShadow: '0 6px 20px rgba(255, 255, 255, 0.3)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.06), rgba(0, 0, 0, 0.9))',
          borderRadius: '12px',
          boxShadow: '0 6px 20px rgba(0, 0, 0, 0.4)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            background: 'linear-gradient(90deg, #ffffff, #e0e0e0)', // White-to-gray gradient
            color: '#0a0a0a', // Black text on hover
          },
        },
      },
    },
  },
});

export default theme;